<div class="container">
  <div class="top-bar">
    <div class="title">RESET PASSWORD</div>
    <div class="close">
      <cs-icon-button iconType="icon" icon="fi-x" size="12" color="secondary" (buttonClick)="close()"> </cs-icon-button>
    </div>
  </div>
  <div class="content">
    <div class="text">Enter your email address and we'll send you a password reset code</div>
    <form [formGroup]="form">
      <div class="input-box">
        <cs-input
          [label]="'Enter your email'"
          [placeholder]="''"
          [hasError]="loginEmailHasError"
          [errorHint]="loginEmailErrorText"
          formControlName="email"
          prefixIconName="fi-user1"
        />
      </div>
    </form>
    <cs-button
      class="submit"
      size="large"
      label="Submit"
      [disabled]="!form.valid || loading"
      [loading]="loading"
      (buttonClick)="submit()"
    ></cs-button>
  </div>
</div>
